<template>
  <!-- 图片文件上传预览容器 -->
  <div class="tableDialog">
    <el-dialog
      :title="title"
      :visible.sync="isShow"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      @closed="close"
      width="70%"
    >
      <div class="tips">{{ tips }}</div>
      <search-bar>
        <template>
          <el-select
            v-show="isSelBox"
            v-model="selBoxVal"
            :placeholder="selBoxName"
            @change="setSelBox"
            style="width: 100px; margin-right: 5px"
          >
            <el-option
              v-for="(item, index) in selBoxList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchName"
          >
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="search"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-check"
            @click="moreSel"
            v-show="isMoreSel"
            >确定
          </el-button>
        </template>
      </search-bar>
      <el-table
        :data="tableData"
        stripe
        border
        ref="multipleTable"
        @row-click="rowClick"
        @row-dblclick="rowDbClick"
        @selection-change="selectionChange"
        tooltip-effect="dark"
        style="width: 100%; height: 400px; overflow: auto"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          align="center"
          width="55"
          v-if="isMoreSel"
        >
        </el-table-column>
        <el-table-column
          v-for="(value, key) in imgHead"
          :key="key"
          align="center"
          show-overflow-tooltip
          :label="value"
        >
          <template slot-scope="scope">
            <img-view :imgList="[{ url: scope.row[key], id: 0 }]"></img-view>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(value, key) in tableHead"
          align="center"
          :key="key"
          show-overflow-tooltip
          :label="value"
        >
          <template slot-scope="scope">
            <span>{{ scope.row[key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage"
        :pageSize="pageSize"
        :currIndex="currPage"
        :page-sizes="[10, 20, 40, 100]"
        @hanCurrChange="hanCurrChange"
        @hanSiChange="hanSizesChange"
        :layout="layout"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "tableDialog",
  props: {
    // 标题
    title: {
      type: String,
      default: "数据列表",
    },
    // 提示信息
    tips: {
      type: String,
      default: "",
    },
    // 是否可以多选
    isMoreSel: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper",
    },
    // 是否显示选择框
    isSelBox: {
      type: Boolean,
      default: false,
    },
    // 选择框名称
    selBoxName: {
      type: String,
      default: "",
    },
    // 选择框列表
    selBoxList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 选择框值
    selBoxValue: {
      type: String,
      default: "",
    },
    // 搜索值
    searchValue: {
      type: String,
      default: "",
    },
    // 表格数据
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 表格头部数据
    tableHead: {
      type: Object,
      default() {
        return {};
      },
    },
    // 页码
    currPage: {
      type: Number,
      default: 1,
    },
    // 总页数
    allPage: {
      type: Number,
      default: 0,
    },
    // 页数量
    pageSize: {
      type: Number,
      default: 10,
    },
    // 图片标题对应key
    imgHead: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    this.searchName = this.searchValue;
    this.selBoxVal = this.selBoxValue;
  },
  data() {
    return {
      selectedList: [],
      searchName: "",
      selBoxVal: "",
      isShow: true,
    };
  },
  methods: {
    // 搜索事件
    search() {
      this.$emit("update:currPage", 1);
      this.$emit("search", this.searchName, true);
    },
    // 选中并确定事件
    moreSel() {
      this.$emit("moreSel", this.selectedList);
      this.$refs.multipleTable.clearSelection();
    },
    // 选择框选择事件
    setSelBox(value) {
      this.selBoxVal = value;
      this.$emit("selBox", this.selBoxVal);
    },
    // 点击事件
    rowClick(row) {
      if (!this.isMoreSel) {
        this.rowDbClick(row);
      }
    },
    // 双击事件
    rowDbClick(row) {
      this.$emit("rowClick", row);
    },
    // 选择数据事件
    selectionChange(section) {
      this.selectedList = section;
    },
    // 页码改变事件
    hanCurrChange(val) {
      this.$emit("hanCurrChange", val);
    },
    hanSizesChange(val) {
      this.$emit("hanSizesChange", val);
    },
    // 组件关闭事件
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.tableDialog {
  width: 100%;
  height: 100%;
}
.tips {
  box-sizing: border-box;
  width: 100%;
  padding: 0 10px;
  font-size: 14px;
  color: #ff001d;
  line-height: 24px;
}
</style>
